import { Injectable } from '@angular/core';
import * as dagre from '@dagrejs/dagre';
import { graphlib } from '@dagrejs/dagre';
import Graph = graphlib.Graph;
import { DirectionType } from '../edit/models/direction-type.enum';
import { INodeViewModel } from '../../core/visual/work-flow-editor/models/i-node-view-model';
import { IFlowViewModel } from '../../core/visual/work-flow-editor/models/i-flow-view-model';
import { FFlowService } from '../../core/visual/work-flow-editor/f-flow.service';
import { EventsFlowDataFormService } from './events-flow-data-form.service';

@Injectable()
export class EventsFlowAlignmentService {
  private readonly fFlowService = new FFlowService<any>(this._eventsFlowDataFormService);

  constructor(private _eventsFlowDataFormService: EventsFlowDataFormService) {}

  public getAlignedNodes(direction: DirectionType, viewModel: IFlowViewModel<any>): INodeViewModel<any>[] {
    const graph = new dagre.graphlib.Graph();

    this.setGraph(graph, direction, viewModel);
    return this.getNodes(graph, viewModel.nodes);
  }

  private getNodes(graph: Graph, nodes: INodeViewModel<any>[]): INodeViewModel<any>[] {
    return graph.nodes().map(x => {
      const graphNode = graph.node(x);
      const viewNode = nodes.find(viewNode => viewNode.key === x);

      return {
        ...viewNode,
        position: { x: graphNode.x, y: graphNode.y },
      };
    });
  }

  private setGraph(graph: Graph, direction: DirectionType, viewModel: IFlowViewModel<any>): void {
    graph.setGraph({ rankdir: direction });

    viewModel.nodes.forEach(node => {
      graph.setNode(node.key, { width: 400, height: 150 });

      const parentNode = this.fFlowService.findParentNode(node.key, viewModel);

      if (parentNode) {
        graph.setEdge(parentNode.key, node.key, {});
      }
    });
    dagre.layout(graph);
  }
}
